var map = {
	"./breathing-problem.svg": 65771,
	"./chest-pain.svg": 39121,
	"./child-health.svg": 41776,
	"./cold.svg": 91959,
	"./eye.svg": 29684,
	"./female-health.svg": 14688,
	"./fever.svg": 59701,
	"./headache.svg": 54798,
	"./insomnia.svg": 24233,
	"./joint-pain.svg": 10432,
	"./mental-health.svg": 33093,
	"./nausea.svg": 75172,
	"./sorethroat.svg": 1702,
	"./tooth.svg": 77981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90857;